"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetsApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var AdSetsApi = /** @class */ (function (_super) {
    __extends(AdSetsApi, _super);
    function AdSetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds an entire ad set hierarchy with ads to an existing campaign.
     * Adds an entire ad set hierarchy with ads to an existing campaign
     */
    AdSetsApi.prototype.addAdsetsToCampaignRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling addAdsetsToCampaign.');
                        }
                        if (requestParameters.addAdsetsToCampaignRequest === null || requestParameters.addAdsetsToCampaignRequest === undefined) {
                            throw new runtime.RequiredError('addAdsetsToCampaignRequest', 'Required parameter requestParameters.addAdsetsToCampaignRequest was null or undefined when calling addAdsetsToCampaign.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/internal_adsets_hierarchy".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AddAdsetsToCampaignRequestToJSON)(requestParameters.addAdsetsToCampaignRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AddAdsetsToCampaignResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Adds an entire ad set hierarchy with ads to an existing campaign.
     * Adds an entire ad set hierarchy with ads to an existing campaign
     */
    AdSetsApi.prototype.addAdsetsToCampaign = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addAdsetsToCampaignRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get SKAd Network availability for an ad account.
     * Check SKAd Network availability for an ad account.
     */
    AdSetsApi.prototype.checkSKAdAvailabilityRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling checkSKAdAvailability.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/skad".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SKAdAvailabilityReponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get SKAd Network availability for an ad account.
     * Check SKAd Network availability for an ad account.
     */
    AdSetsApi.prototype.checkSKAdAvailability = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkSKAdAvailabilityRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get SKAd Network availability by flight ID.
     * Check SKAd Network availability by flight ID.
     */
    AdSetsApi.prototype.checkSkadAvailabilityByFlightIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling checkSkadAvailabilityByFlightId.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling checkSkadAvailabilityByFlightId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/{ad_set_id}/skad".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SKAdAvailabilityReponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get SKAd Network availability by flight ID.
     * Check SKAd Network availability by flight ID.
     */
    AdSetsApi.prototype.checkSkadAvailabilityByFlightId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkSkadAvailabilityByFlightIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a new ad set.
     * Create an Ad Set
     */
    AdSetsApi.prototype.createAdSetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAdSet.');
                        }
                        if (requestParameters.adSetCreateRequest === null || requestParameters.adSetCreateRequest === undefined) {
                            throw new runtime.RequiredError('adSetCreateRequest', 'Required parameter requestParameters.adSetCreateRequest was null or undefined when calling createAdSet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdSetCreateRequestToJSON)(requestParameters.adSetCreateRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new ad set.
     * Create an Ad Set
     */
    AdSetsApi.prototype.createAdSet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAdSetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a draft ad set under a given ad account.
     * Create a Draft Ad Set
     */
    AdSetsApi.prototype.createAdSetDraftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAdSetDraft.');
                        }
                        if (requestParameters.adSetDraftCreateRequest === null || requestParameters.adSetDraftCreateRequest === undefined) {
                            throw new runtime.RequiredError('adSetDraftCreateRequest', 'Required parameter requestParameters.adSetDraftCreateRequest was null or undefined when calling createAdSetDraft.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/drafts/ad_sets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdSetDraftCreateRequestToJSON)(requestParameters.adSetDraftCreateRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetDraftFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a draft ad set under a given ad account.
     * Create a Draft Ad Set
     */
    AdSetsApi.prototype.createAdSetDraft = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAdSetDraftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a draft version of a published ad set under a given ad account.
     * Create a Draft Ad Set from a Published Ad Set
     */
    AdSetsApi.prototype.createDraftFromAdSetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createDraftFromAdSet.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling createDraftFromAdSet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/{ad_set_id}/drafts".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetDraftFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a draft version of a published ad set under a given ad account.
     * Create a Draft Ad Set from a Published Ad Set
     */
    AdSetsApi.prototype.createDraftFromAdSet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDraftFromAdSetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes the given draft ad set.
     * Delete a Draft Ad Set
     */
    AdSetsApi.prototype.deleteAdSetDraftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling deleteAdSetDraft.');
                        }
                        if (requestParameters.draftAdSetId === null || requestParameters.draftAdSetId === undefined) {
                            throw new runtime.RequiredError('draftAdSetId', 'Required parameter requestParameters.draftAdSetId was null or undefined when calling deleteAdSetDraft.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/drafts/ad_sets/{draft_ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("draft_ad_set_id", "}"), encodeURIComponent(String(requestParameters.draftAdSetId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes the given draft ad set.
     * Delete a Draft Ad Set
     */
    AdSetsApi.prototype.deleteAdSetDraft = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAdSetDraftRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get an ad set by ID.
     * Get Ad Set by ID
     */
    AdSetsApi.prototype.getAdSetByIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAdSetById.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling getAdSetById.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/{ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get an ad set by ID.
     * Get Ad Set by ID
     */
    AdSetsApi.prototype.getAdSetById = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetByIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get one ad set by id, without an ad account.
     * Get an Ad Set By ID without ad account context
     */
    AdSetsApi.prototype.getAdSetByIdWithoutAdAccountRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling getAdSetByIdWithoutAdAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_sets/{ad_set_id}".replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get one ad set by id, without an ad account.
     * Get an Ad Set By ID without ad account context
     */
    AdSetsApi.prototype.getAdSetByIdWithoutAdAccount = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetByIdWithoutAdAccountRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns draft ad set based on a given draft ad set ID.
     * Get Draft Ad Set by ID
     */
    AdSetsApi.prototype.getAdSetDraftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAdSetDraft.');
                        }
                        if (requestParameters.draftAdSetId === null || requestParameters.draftAdSetId === undefined) {
                            throw new runtime.RequiredError('draftAdSetId', 'Required parameter requestParameters.draftAdSetId was null or undefined when calling getAdSetDraft.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/drafts/ad_sets/{draft_ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("draft_ad_set_id", "}"), encodeURIComponent(String(requestParameters.draftAdSetId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetDraftFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns draft ad set based on a given draft ad set ID.
     * Get Draft Ad Set by ID
     */
    AdSetsApi.prototype.getAdSetDraft = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetDraftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all ad sets.
     * Get Ad Sets
     */
    AdSetsApi.prototype.getAdSetsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = Array.from(requestParameters.statuses).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.campaignIds) {
                            queryParameters['campaign_ids'] = requestParameters.campaignIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.adSetIds) {
                            queryParameters['ad_set_ids'] = requestParameters.adSetIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.adIds) {
                            queryParameters['ad_ids'] = requestParameters.adIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.linkedAssetIds) {
                            queryParameters['linked_asset_ids'] = requestParameters.linkedAssetIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.countryCodes) {
                            queryParameters['country_codes'] = Array.from(requestParameters.countryCodes).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.promotionGoal !== undefined) {
                            queryParameters['promotion_goal'] = requestParameters.promotionGoal;
                        }
                        if (requestParameters.promotionTargetId !== undefined) {
                            queryParameters['promotion_target_id'] = requestParameters.promotionTargetId;
                        }
                        if (requestParameters.startTimeLt !== undefined) {
                            queryParameters['start_time_lt'] = requestParameters.startTimeLt.toISOString();
                        }
                        if (requestParameters.startTimeLte !== undefined) {
                            queryParameters['start_time_lte'] = requestParameters.startTimeLte.toISOString();
                        }
                        if (requestParameters.startTimeGt !== undefined) {
                            queryParameters['start_time_gt'] = requestParameters.startTimeGt.toISOString();
                        }
                        if (requestParameters.startTimeGte !== undefined) {
                            queryParameters['start_time_gte'] = requestParameters.startTimeGte.toISOString();
                        }
                        if (requestParameters.endTimeLt !== undefined) {
                            queryParameters['end_time_lt'] = requestParameters.endTimeLt.toISOString();
                        }
                        if (requestParameters.endTimeLte !== undefined) {
                            queryParameters['end_time_lte'] = requestParameters.endTimeLte.toISOString();
                        }
                        if (requestParameters.endTimeGt !== undefined) {
                            queryParameters['end_time_gt'] = requestParameters.endTimeGt.toISOString();
                        }
                        if (requestParameters.endTimeGte !== undefined) {
                            queryParameters['end_time_gte'] = requestParameters.endTimeGte.toISOString();
                        }
                        if (requestParameters.userScope !== undefined) {
                            queryParameters['user_scope'] = requestParameters.userScope;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_sets",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all ad sets.
     * Get Ad Sets
     */
    AdSetsApi.prototype.getAdSets = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all ad sets for the ad account.
     * Get Ad Sets by Ad Account ID
     */
    AdSetsApi.prototype.getAdSetsByAdAccountIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAdSetsByAdAccountId.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.internalLimit !== undefined) {
                            queryParameters['internal_limit'] = requestParameters.internalLimit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        if (requestParameters.campaignIds) {
                            queryParameters['campaign_ids'] = requestParameters.campaignIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.adSetIds) {
                            queryParameters['ad_set_ids'] = requestParameters.adSetIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.adIds) {
                            queryParameters['ad_ids'] = requestParameters.adIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.statuses) {
                            queryParameters['statuses'] = Array.from(requestParameters.statuses).join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all ad sets for the ad account.
     * Get Ad Sets by Ad Account ID
     */
    AdSetsApi.prototype.getAdSetsByAdAccountId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdSetsByAdAccountIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sets the review status on the ad-set along wth rejection reason if applicable.
     * Approve or reject an Ad Set
     */
    AdSetsApi.prototype.reviewAdSetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling reviewAdSet.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling reviewAdSet.');
                        }
                        if (requestParameters.reviewAdSetRequest === null || requestParameters.reviewAdSetRequest === undefined) {
                            throw new runtime.RequiredError('reviewAdSetRequest', 'Required parameter requestParameters.reviewAdSetRequest was null or undefined when calling reviewAdSet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/{ad_set_id}/review".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.ReviewAdSetRequestToJSON)(requestParameters.reviewAdSetRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sets the review status on the ad-set along wth rejection reason if applicable.
     * Approve or reject an Ad Set
     */
    AdSetsApi.prototype.reviewAdSet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reviewAdSetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set SkAd Network configuration for an ad set.
     * Set SKAd enablement for an ad set.
     */
    AdSetsApi.prototype.setSkadForAdSetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling setSkadForAdSet.');
                        }
                        if (requestParameters.adSetSkadRequest === null || requestParameters.adSetSkadRequest === undefined) {
                            throw new runtime.RequiredError('adSetSkadRequest', 'Required parameter requestParameters.adSetSkadRequest was null or undefined when calling setSkadForAdSet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/skad".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdSetSkadRequestToJSON)(requestParameters.adSetSkadRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetSkadResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Set SkAd Network configuration for an ad set.
     * Set SKAd enablement for an ad set.
     */
    AdSetsApi.prototype.setSkadForAdSet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setSkadForAdSetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Partially update an ad set information based on payload.
     * Update Ad Set
     */
    AdSetsApi.prototype.updateAdSetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateAdSet.');
                        }
                        if (requestParameters.adSetId === null || requestParameters.adSetId === undefined) {
                            throw new runtime.RequiredError('adSetId', 'Required parameter requestParameters.adSetId was null or undefined when calling updateAdSet.');
                        }
                        if (requestParameters.adSetPatchRequest === null || requestParameters.adSetPatchRequest === undefined) {
                            throw new runtime.RequiredError('adSetPatchRequest', 'Required parameter requestParameters.adSetPatchRequest was null or undefined when calling updateAdSet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/ad_sets/{ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("ad_set_id", "}"), encodeURIComponent(String(requestParameters.adSetId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdSetPatchRequestToJSON)(requestParameters.adSetPatchRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Partially update an ad set information based on payload.
     * Update Ad Set
     */
    AdSetsApi.prototype.updateAdSet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAdSetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the given existing draft ad set.
     * Update a Draft Ad Set
     */
    AdSetsApi.prototype.updateAdSetDraftRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling updateAdSetDraft.');
                        }
                        if (requestParameters.draftAdSetId === null || requestParameters.draftAdSetId === undefined) {
                            throw new runtime.RequiredError('draftAdSetId', 'Required parameter requestParameters.draftAdSetId was null or undefined when calling updateAdSetDraft.');
                        }
                        if (requestParameters.adSetDraftUpdateRequest === null || requestParameters.adSetDraftUpdateRequest === undefined) {
                            throw new runtime.RequiredError('adSetDraftUpdateRequest', 'Required parameter requestParameters.adSetDraftUpdateRequest was null or undefined when calling updateAdSetDraft.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/drafts/ad_sets/{draft_ad_set_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("draft_ad_set_id", "}"), encodeURIComponent(String(requestParameters.draftAdSetId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdSetDraftUpdateRequestToJSON)(requestParameters.adSetDraftUpdateRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AdSetDraftFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the given existing draft ad set.
     * Update a Draft Ad Set
     */
    AdSetsApi.prototype.updateAdSetDraft = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAdSetDraftRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AdSetsApi;
}(runtime.BaseAPI));
exports.AdSetsApi = AdSetsApi;
